export const readStorageFileFailed = 'readStorageFileFailed'
export const updateElectronAppFailed = 'updateElectronAppFailed'
export const getValidTokenFailed = 'getValidTokenFailed'
export const readCreatorMineUserFailed = 'readCreatorMineUserFailed'
export const appInitFailed = 'appInitFailed'
export const clientAxiosError = 'clientAxiosError'
export const onlyfansRequestError = 'onlyfansRequestError'
export const onlyfansQueueError = 'onlyfansQueueError'
export const onlyfansSchemaError = 'onlyfansSchemaError'
export const boundaryError = 'boundaryError'
